export default __webpack_public_path__ + "static/media/Spiderman2_06.92396c53.png";